// extracted by mini-css-extract-plugin
export var countdown = "Countdown-module--countdown--4e4fb";
export var isEminent = "Countdown-module--isEminent--09faf";
export var isSoon = "Countdown-module--isSoon--7d9e7";
export var root = "Countdown-module--root--94fa6";